import {UploadFile} from "antd/lib/upload/interface";

import React, {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import {DeleteOutlined, LoadingOutlined, PaperClipOutlined} from "@ant-design/icons";
import {Enum} from "@/enums/system";
import {formatFileToUrl, getFileType} from "@/utils/download";
import {Button, message, Progress} from "antd";
import {FileUploadUtility} from "@/components/WdiControls/WdiFileUpload";

type FileItemProps = {
  file: UploadFile;
  disabled?: boolean;
  onDel?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void
}

export type WdiFileItemRef = {
  itemDownload: () => Promise<boolean>;
}

type WdiFileItemState = {
  file?: UploadFile;
  isLoading: boolean;
  showDel: boolean;
  disabled: boolean;
  itemClz: string;
}

const emptyFileItem: WdiFileItemState = {
  file: undefined,
  isLoading: false,
  showDel: false,
  disabled: false,
  itemClz: '',
};

const WdiFileItem = forwardRef<WdiFileItemRef, FileItemProps>((props, ref) => {

  const [fileItem, setFileItem] = useState<WdiFileItemState>(emptyFileItem);

  useImperativeHandle(ref, () => ({
    itemDownload
  }));

  useEffect(() => {
    const file = props.file;
    if (!file) {
      setFileItem(emptyFileItem)
      return;
    }
    setFileItem({
      file: props.file,
      isLoading: (file.status === 'uploading' || !file.url),
      showDel: !!props.onDel,
      disabled: props.disabled ?? false,
      itemClz: 'ant-upload-list-item ant-upload-list-item-' + file.status + ' ant-upload-list-item-list-type-text'
    })
  }, [props.file])

  const itemDownload = () => {
    if (!fileItem.file) {
      return new Promise<boolean>(resolve => resolve(false));
    }
    setFileItem({
      ...fileItem,
      isLoading: true
    });
    return FileUploadUtility.download(fileItem.file).then(res => {
      setFileItem({
        ...fileItem,
        isLoading: false
      });
      return true;
    }).catch(() => {
      setFileItem({
        ...fileItem,
        isLoading: false
      });
      return false;
    })
  }

  /**
   * 文件下载或者预览 路由
   * @param isDownload true直接下载不进视图
   */
  const downloadOrPreviewRouter = () => {
    if (Enum.FileType.NONE == getFileType(fileItem.file?.name)) {
      itemDownload().then(isOk => {
        if (isOk) {
          message.success("文件【" + fileItem.file?.name + "】下载成功")
          return;
        }
        message.error("文件下载失败，请联系管理员！")
      });
      return;
    }
    //支持预览的文件打开预览视图
    window.open(formatFileToUrl(fileItem.file, '/file/preview'))
  }

  return (<>
    <div className={fileItem.itemClz}>
      <div className="ant-upload-list-item-info">
            <span className="ant-upload-span">
              <div className="ant-upload-text-icon">
                {fileItem.isLoading && <LoadingOutlined/>}
                {!fileItem.isLoading && <PaperClipOutlined/>}
              </div>
              {!fileItem.isLoading &&
                <a
                  className="ant-upload-list-item-name"
                  title={fileItem.file?.name}
                  onClick={() => downloadOrPreviewRouter()}
                >
                  {fileItem.file?.name}
                </a>
              }
              {fileItem.isLoading &&
                <span className="ant-upload-list-item-name" title={fileItem.file?.name}>{fileItem.file?.name}</span>}
              {fileItem.showDel && !fileItem.disabled && <span className="ant-upload-list-item-card-actions">
                <Button
                  type="text"
                  title="删除文件"
                  size="small"
                  className="ant-btn-icon-only ant-upload-list-item-card-actions-btn"
                  onClick={props.onDel}
                >
                  <DeleteOutlined/>
                </Button>
              </span>
              }
            </span>
      </div>
      {
        fileItem.isLoading &&
        <div className="ant-upload-list-item-progress">
          <Progress percent={fileItem.file?.percent} size="small"/>
        </div>
      }
    </div>
  </>);
})

export {WdiFileItem};
